import { useLocale } from 'next-intl'
import { useLocalizedField } from '@/hooks/useLocalizedField'

export default function ArtisanatCard({item}:any){
    const locale = useLocale()
    const { getLocalizedField } = useLocalizedField()
    
    const name = getLocalizedField(item, 'name', item.name || 'Unknown')
    const address = getLocalizedField(item, 'address', item.address || '')
    
    return(
        <a href={`/${locale}/artisanats/${item.slug}`} className="group cursor-pointer" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
           <div className="flex flex-col gap-4">

                {/* Image with fixed height */}
                <div className="h-72 overflow-hidden rounded-2xl">
                    <img
                        src={item.vignette}
                        alt={name}
                        className="w-full h-full object-cover transition duration-500 group-hover:scale-110"
                    />
                </div>

                {/* Title & Address */}
                <div className="flex flex-col gap-2">
                    <h3 className="text-foreground text-xl font-semibold truncate">
                        {name}
                    </h3>

                    <p className="text-xs text-foreground line-clamp-2">
                        {address}
                    </p>
                </div>

            </div>
        </a>
    )
}